import { myAxios } from "../../utils/serverContextPath";
import { useTranslation } from "react-i18next";
export const getCommuneById = (id) => {
  return myAxios.get(`commune/getbyid/${id}`);
};

export const getCommuneAllPage = (
  keyword = "",
  pageNumber = 0,
  itemsPerPage = 10,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("commune/getallpage", {
    params: {
      keyword,
      page: pageNumber,
      size: itemsPerPage,
      sortList,
      sortOrder,
    },
  });
};

export const getAllCommune = (
  keyword = "",
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("commune/getall", {
    params: {
      keyword,
      sortList,
      sortOrder,
    },
  });
};


export const getCommuneByCodeWilayaAllPage = (
  codeWilaya = "",
  keyword = "",
  pageNumber = 0,
  itemsPerPage = 10,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("commune/getallcodewilpage", {
    params: {
      codewil: codeWilaya,
      keyword,
      page: pageNumber,
      size: itemsPerPage,
      sortList,
      sortOrder,
    },
  });
};

export const deleteCommune = (id) => {
  return myAxios.delete(`commune/delete/${id}`);
};

export const postCommune = (data) => {
  return myAxios.post("commune/save/insert", data);
};

export const updateCommune = (data) => {
  return myAxios.post("commune/save/Update", data);
};

export const findSimilarCommune = (
  keyword,
  tauxsimilarity = 0.8,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("commune/similarity", {
    params: {
      keyword,
      tauxsimilarity,
      sortList,
      sortOrder,
    },
  });
};


export const getAllCommuneByWilayaId = (
  idWil = "",
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("commune/getallcommunebywilayaid", {
    params: {
      idWil,
      sortList,
      sortOrder,
    },
  });
};


export const getAllCommunePageByCodeWilaya = (
  codeWilaya = "",
  keyword = "",
  pageNumber = 0,
  itemsPerPage = 10,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("commune/getallcommunepagebycodewilaya", {
    params: {
      codewil: codeWilaya,
      keyword,
      page: pageNumber,
      size: itemsPerPage,
      sortList,
      sortOrder,
    },
  });
};

